package com.mgacreative.hotel.domain.model

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class PricePeriod(
    val id: String = "",
    @SerialName("tenant_id") val tenantId: String = "",
    @SerialName("room_type") val roomType: String = "",
    val name: String = "",
    @SerialName("start_date") val startDate: String = "", // YYYY-MM-DD
    @SerialName("end_date") val endDate: String = "",     // YYYY-MM-DD
    val price: Double = 0.0,
    @SerialName("created_at") val createdAt: String? = null
)
